import * as loadingState from '@blueberry/constants/loadingState';

export const types = {
  FETCH_SCHOOL_SUBJECTS: 'FETCH_SCHOOL_SUBJECTS',
  FETCH_SCHOOL_SUBJECTS_SUCCESS: 'FETCH_SCHOOL_SUBJECTS_SUCCESS',
  FETCH_SCHOOL_SUBJECTS_FAILURE: 'FETCH_SCHOOL_SUBJECTS_FAILURE',
  CHANGE_SCHOOL_SUBJECT: 'CHANGE_SCHOOL_SUBJECT',
  SHOW_WIDGET: 'SHOW_WIDGET',
  HIDE_WIDGET: 'HIDE_WIDGET',
  SHOW_WIDGET_MESSAGE_NOTIFICATION: 'SHOW_WIDGET_MESSAGE_NOTIFICATION',
  HIDE_WIDGET_MESSAGE_NOTIFICATION: 'HIDE_WIDGET_MESSAGE_NOTIFICATION',
};

export const fetchSchoolSubjects = () => ({
  type: types.FETCH_SCHOOL_SUBJECTS,
});

export const fetchSchoolSubjectsSuccess = subjects => ({
  type: types.FETCH_SCHOOL_SUBJECTS_SUCCESS,
  payload: {
    subjects,
  },
});

export const fetchSchoolSubjectsFailure = () => ({
  type: types.FETCH_SCHOOL_SUBJECTS_FAILURE,
});

export const chagneSchoolSubject = id => ({
  type: types.CHANGE_SCHOOL_SUBJECT,
  payload: {
    id,
  },
});

export const showWidget = () => ({
  type: types.SHOW_WIDGET,
});

export const hideWidget = () => ({
  type: types.HIDE_WIDGET,
});
export const showWidgetUnreadNotification = () => ({
  type: types.SHOW_WIDGET_MESSAGE_NOTIFICATION,
});
export const hideWidgetUnreadNotification = () => ({
  type: types.HIDE_WIDGET_MESSAGE_NOTIFICATION,
});
const initialState = {
  loadingStatus: loadingState.EMPTY,
  subjects: [],
  selectedSubjectId: undefined,
  widgetVisible: false,
  widgetHasUnreadMessage: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_SCHOOL_SUBJECTS_SUCCESS:
      return {
        ...state,
        subjects: action.payload.subjects,
        loadingStatus: loadingState.READY,
      };
    case types.CHANGE_SCHOOL_SUBJECT:
      return {
        ...state,
        selectedSubjectId: action.payload.id,
      };
    case types.SHOW_WIDGET:
      return {
        ...state,
        widgetVisible: true,
      };
    case types.HIDE_WIDGET:
      return {
        ...state,
        widgetVisible: false,
      };
    case types.SHOW_WIDGET_MESSAGE_NOTIFICATION:
      return {
        ...state,
        widgetHasUnreadMessage: true,
      };
    case types.HIDE_WIDGET_MESSAGE_NOTIFICATION:
      return {
        ...state,
        widgetHasUnreadMessage: false,
      };
    default:
      return state;
  }
};

export default reducer;

export const getSchoolSubjects = state => state.dashboard.subjects;
export const getSelectedSubjectId = state => state.dashboard.selectedSubjectId;
export const getLoadingStatus = state => state.dashboard.loadingStatus;
export const getWidgetVisible = state => state.dashboard.widgetVisible;
export const getWidgetHasUnreadMessage = state =>
  state.dashboard.widgetHasUnreadMessage;



// WEBPACK FOOTER //
// ./app/redux/dashboard.js